import { useEffect, useRef, useState } from "react";
import Background from "./Background";
import { useNavigate, useLocation } from "react-router-dom";
import "./Settings.css";
import { ReactComponent as Logo } from "../assets/Logo.svg";
import { firestore, auth, database } from "../firebase/firebaseConfig";
import {
  doc,
  updateDoc,
  getDocs,
  collection,
  where,
  query,
} from "firebase/firestore";
import { signOut } from "firebase/auth";
import { useAuthContext } from "../firebase/AuthContext";
import { remove, ref } from "firebase/database";
import Book from "../assets/book.webp";

function Settings() {
  const [name, setName] = useState("");
  const [language, setLanguage] = useState("English");
  const [change, setChange] = useState(false);
  const [changing, setChanging] = useState(false);
  const [days, setDays] = useState(0);
  const [nameAlreadyInUse, setNameAlreadyInUse] = useState(false);
  const {
    user,
    userData,
    setUserData,
    loading,
    userLanguage,
    userSubscription,
    setUserLanguage,
  } = useAuthContext();
  const [languageFocused, setLanguageFocused] = useState(false);
  const [languageIndex, setLanguageIndex] = useState(userLanguage);
  const navigate = useNavigate();
  const location = useLocation();
  const languages = {
    de: "Deutsch",
    en: "English",
  };

  useEffect(() => {
    if (location.state) {
      if (location.state["reload"]) {
        window.location.reload();
        navigate("/settings", { replace: true });
      }
    }
  }, []);

  useEffect(() => {
    if (userData) {
      setName(userData.name);
      setLanguage(languages[userLanguage]);
      setDays(userSubscription);
    }
  }, [loading]);

  const saveData = async () => {
    setChanging(true);
    checkIfNameValid().then(async (valid) => {
      if (valid) {
        await updateDoc(doc(firestore, "users", user.uid), {
          name: name,
          language: languageIndex,
        });
        setChanging(false);
        setChange(false);
        setUserLanguage(languageIndex);
        setUserData({
          ...userData,
          name: name,
        });
      } else {
        setNameAlreadyInUse(true);
        setChanging(false);
      }
    });
  };

  const logout = async () => {
    await signOut(auth);
    remove(ref(database, `users/${user.uid}`));
    localStorage.clear();
    window.location.reload();
  };

  const checkIfNameValid = async () => {
    setNameAlreadyInUse(false);

    if (name == userData.name) {
      return true;
    }

    try {
      const q = query(
        collection(firestore, "users"),
        where("name", "==", name)
      );
      const querySnapshot = await getDocs(q);

      return querySnapshot.empty;
    } catch (error) {
      return false;
    }
  };

  const texts = {
    de: {
      name: "Name",
      language: "Sprache",
      leftDays: "Verbleibende Tage",
      days: "Tage",
      save: "Speichern",
      logout: "Ausloggen",
      nameAlreadyInUse: "Dieser Name ist bereits vergeben",
    },
    en: {
      name: "Name",
      language: "Language",
      leftDays: "remaining days",
      days: "days",
      save: "Save",
      logout: "Log out",
      nameAlreadyInUse: "This name is already taken",
    },
  };

  return (
    <>
      <Background />
      <div className="settings">
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            alignItems: "center",
            height: "500px",
          }}
        >
          <div className="data">
            <div className="name field" style={{ width: "80%" }}>
              <p>{texts[userLanguage]["name"]}</p>
              <input
                maxLength={18}
                value={name}
                onChange={(e) => {
                  setName(e.currentTarget.value);
                  setChange(true);
                }}
              ></input>
              {nameAlreadyInUse && (
                <span style={{ color: "red" }}>
                  {texts[userLanguage]["nameAlreadyInUse"]}
                </span>
              )}
            </div>
            <div className="language field" style={{ width: "60%" }}>
              <p>{texts[userLanguage]["language"]}</p>
              <div
                className="input-field "
                onClick={() => setLanguageFocused(!languageFocused)}
                value={language}
                onChange={(e) => {
                  setLanguage(e.currentTarget.value);
                }}
              >
                {language}
              </div>
              {languageFocused && (
                <div className="language-list">
                  {Object.entries(languages).map(([key, value], index) => (
                    <div
                      key={key}
                      onClick={() => {
                        setLanguage(value);
                        setLanguageIndex(key);
                        setLanguageFocused(false);
                        setChange(true);
                      }}
                    >
                      {value}
                    </div>
                  ))}
                </div>
              )}
            </div>
            {changing ? (
              <Logo
                className="loading"
                style={{
                  marginTop: "40px",
                  height: "15%",
                  filter: "drop-shadow(0px 0px 10px white)",
                }}
              ></Logo>
            ) : (
              <div
                className="save"
                style={{ display: !change && "none" }}
                onClick={() => saveData()}
              >
                {texts[userLanguage]["save"]}
              </div>
            )}
          </div>

          <div className="logout" onClick={() => logout()}>
            <p>{user.email}</p>
            <div>{texts[userLanguage]["logout"]}</div>
          </div>
        </div>
        <div className="subscription">
          <p>
            {texts[userLanguage]["leftDays"]}: {days}
          </p>
          <div
            className="package"
            style={{ marginTop: "50px" }}
            onClick={() =>
              navigate("/payment?id=price_1R0jShEiJZm6GgyM9rUfnuiT")
            }
          >
            <div>
              + 30 {texts[userLanguage]["days"]}
              <span
                style={{ display: "flex", gap: "10px", alignItems: "center" }}
              >
                + 4 <img src={Book} style={{ height: "34px" }}></img>
              </span>
            </div>
            <span style={{ borderTop: "2px white solid" }}>6,99€</span>
          </div>
          <div
            className="package"
            onClick={() =>
              navigate("/payment?id=price_1R0jTqEiJZm6GgyMqcDlUzvK")
            }
          >
            <div>
              + 90 {texts[userLanguage]["days"]}
              <span
                style={{ display: "flex", gap: "10px", alignItems: "center" }}
              >
                + 12 <img src={Book} style={{ height: "34px" }}></img>
              </span>
            </div>
            <span style={{ borderTop: "2px white solid" }}>18,99€</span>
          </div>
        </div>
      </div>
    </>
  );
}

export default Settings;
